/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { IApplicationLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';

import { isObjectEmpty } from '../../utils/vs-logs.utils';

type TRequestDetails = Pick<IApplicationLog,
'method' | 'http_version' | 'request_length' | 'request_content_type'
>;

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting request details from an L7 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'requestDetails',
})
export class RequestDetailsPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IApplicationLog): TRequestDetails | null {
        if (!log) {
            return null;
        }

        const {
            method,
            http_version,
            request_length,
            request_content_type,
        } = log;

        const requestDetails = {
            method,
            http_version,
            request_length,
            request_content_type,
        };

        if (isObjectEmpty(requestDetails)) {
            return null;
        }

        return requestDetails;
    }
}
